import store from "@/store/index";
import router from "@/router";

//Go to dashbord if user is not ekstern
function checkCompanyAccess(to, from, next) {
  const isTrysilhus = store.getters["shared/isTrysilhus"];
  if (isTrysilhus === false) {
    next();
  } else {
    router.push({ name: "Dashboard" });
  }
}

export default {
  checkCompanyAccess,
};
